import { render, staticRenderFns } from "./tourAreaConfig.vue?vue&type=template&id=1516b0f8&scoped=true&"
import script from "./tourAreaConfig.vue?vue&type=script&lang=js&"
export * from "./tourAreaConfig.vue?vue&type=script&lang=js&"
import style0 from "./tourAreaConfig.vue?vue&type=style&index=0&id=1516b0f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516b0f8",
  null
  
)

export default component.exports